import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass([[_ctx.padding, _ctx.textClass, _ctx.colors], "rounded-3xl flex justify-center"])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}